module.exports = __webpack_public_path__ + "static/media/20_Victor_A@3x.77f4f927.jpg";